import '.er{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.es{padding-left:1.5rem;}.ssr-plugin'
import '.et{margin:1rem 0;}.ssr-plugin'
import '.eu{color:var(--gray-700);}.ssr-plugin'
import '.ev{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="er es et eu ev"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
